import { SITE } from '@/content/site';
import { TID } from '@/constants/testIds';
import { ArrowUpRight } from 'lucide-react';

export default function PromoBar() {
  return (
    <div
      data-testid={TID.promoBar}
      className="w-full bg-[hsl(var(--warm-ink))] text-[hsl(var(--cream))]/95"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-2.5 flex items-center justify-center gap-3 text-[0.65rem] sm:text-[0.7rem] tracking-[0.32em] uppercase font-light">
        <span className="hidden sm:inline-block text-[hsl(var(--champagne))]/80">New Clients</span>
        <span className="hidden sm:inline-block w-1 h-1 rounded-full bg-[hsl(var(--champagne))]/40" />
        <span>{SITE.promoText}</span>
        <a
          data-testid={TID.promoBookBtn}
          href={SITE.booking}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-1 ml-2 text-[hsl(var(--champagne))] hover:text-[hsl(var(--cream))] transition-colors"
        >
          <span className="underline underline-offset-[6px] decoration-[hsl(var(--champagne))]/50 group-hover:decoration-[hsl(var(--cream))]">
            Book
          </span>
          <ArrowUpRight className="w-3 h-3 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.25} />
        </a>
      </div>
    </div>
  );
}
